import { render, staticRenderFns } from "./PolicyCreate.vue?vue&type=template&id=112856e6&"
import script from "./PolicyCreate.vue?vue&type=script&lang=js&"
export * from "./PolicyCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports